import { useIntersectionObserver } from 'usehooks-ts'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { SubscriptionSchedules } from '@/api-client/SubscriptionSchedules'
import { HeaderNav } from '~/components/subscription/branch-lp/header-nav'
import { HeroSection } from '~/components/subscription/branch-lp/hero-section'
import { AdvantagesSection } from '~/components/subscription/branch-lp/advantages-section'
import { GallerySection } from '~/components/subscription/branch-lp/gallery-section'
import { PricingSection } from '~/components/subscription/branch-lp/pricing-section'
import { VasesSection } from '~/components/subscription/branch-lp/vases-section'
import { StepsSection } from '~/components/subscription/branch-lp/steps-section'
import { QualitySection } from '~/components/subscription/branch-lp/quality-section'
import { ReviewsSection } from '~/components/subscription/branch-lp/reviews-section'
import { AboutSection } from '~/components/subscription/branch-lp/about-section'
import { QuestionsSection } from '~/components/subscription/branch-lp/questions-section'
import { SubscribeSection } from '~/components/subscription/branch-lp/subscribe-section'
import { Footer } from '~/components/subscription/branch-lp/footer'
import { BottomBar } from '~/components/subscription/branch-lp/bottom-bar'

async function fetchSchedules() {
  return createClient(SubscriptionSchedules).getSubscriptionSchedules({ upcoming: '1', category: 'green' })
}

async function fetchInBulkPurchasables() {
  return createClient(Subscriptions).getSubscriptionsInBulkPurchasables({ category: 'green' })
}

const deliveryRange = fetchSchedules().then((json) => {
  return json.data.data[0].attributes.deliver_at
    .map((ts) => new Date(ts * 1000))
    .map((date) => `${date.getMonth() + 1}/${date.getDate()}`)
    .join('〜')
})

const inBulkPurchasables = fetchInBulkPurchasables().then((json) => json.data.data)

export const SubscriptionBranch: React.FC = () => {
  const [ref, barVisible] = useIntersectionObserver({ rootMargin: '-300px 0px' })

  return (
    <div className="page-enter">
      <HeaderNav />
      <div className="min-h-screen bg-white font-sans text-main">
        <HeroSection />
        <div ref={ref}>
          <AdvantagesSection />
          <GallerySection />
          <PricingSection />
          <VasesSection inBulkPurchasables={inBulkPurchasables} />
          <StepsSection />
          <QualitySection />
          <ReviewsSection />
          <AboutSection />
          <QuestionsSection />
        </div>
        <SubscribeSection />
        <Footer />
        <BottomBar visible={barVisible} deliveryRange={deliveryRange} />
      </div>
    </div>
  )
}
